import React from "react";
import {LoadingDialog} from "../../../../components/DialogLoading";
import {TwoButtonDialog} from "../../../../designSystem/components/TwoButtonDialog";

export enum PROFILE_EDIT_MODAL_CONTENT {
  LOADING = 'loading',
  SAVED = 'saved'
}

export const ProfileEditModalContent = ({
  onClickSaveConfirm
}) => ({
  [PROFILE_EDIT_MODAL_CONTENT.LOADING]: (
    <LoadingDialog label="載入中" />
  ),
  [PROFILE_EDIT_MODAL_CONTENT.SAVED]: (
    <TwoButtonDialog
      type="success"
      title="已儲存"
      leftLabel="了解"
      leftOnClick={onClickSaveConfirm}
    />
  )
})